import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      
      setAuth: (user, token) => {
        set({ user, token })
        localStorage.setItem('auth_token', token)
      },
      
      logout: () => {
        set({ user: null, token: null })
        localStorage.removeItem('auth_token')
      },
      
      isAuthenticated: () => !!get().token,
      
      hasRole: (role) => get().user?.role === role,
    }),
    {
      name: 'auth-storage',
    }
  )
)